export interface Resource {
  id: number;
  title: string;
  description: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  views: number;
  downloads: number;
  tags: string[];
  contentHtml: string;
  isFeatured: boolean;
  isLatest: boolean;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  count: number;
  icon: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  {
    slug: 'sheji-sucai',
    name: '设计素材',
    description: '高品质设计资源，涵盖UI组件、图标、插画、字体等各类设计元素',
    count: 1286,
    icon: 'ri-palette-line',
  },
  {
    slug: 'yingshi-sucai',
    name: '影视素材',
    description: '4K高清视频素材、动态背景、转场特效及后期调色预设',
    count: 943,
    icon: 'ri-film-line',
  },
  {
    slug: 'yinyue-sucai',
    name: '音乐素材',
    description: '免版税背景音乐、音效素材、配乐合集，适用于各类创作场景',
    count: 567,
    icon: 'ri-music-line',
  },
  {
    slug: 'jiaocheng-ziyuan',
    name: '教程资源',
    description: '从入门到精通的系统教程，涵盖设计、编程、影视后期等热门领域',
    count: 432,
    icon: 'ri-book-open-line',
  },
  {
    slug: 'moban-ziyuan',
    name: '模板资源',
    description: 'PPT模板、简历模板、海报模板、视频模板等一键套用资源',
    count: 758,
    icon: 'ri-file-copy-line',
  },
  {
    slug: 'chajian-gongju',
    name: '插件工具',
    description: '高效创作工具、浏览器插件、设计软件扩展，提升工作流效率',
    count: 321,
    icon: 'ri-tools-line',
  },
];

export const resources: Resource[] = [
  {
    id: 1,
    title: '2024年度精选UI设计组件库合集',
    description: '包含200+高质量UI组件，涵盖按钮、表单、导航、卡片等常用界面元素，支持Figma和Sketch双格式导入，完美适配各种设计项目需求。',
    category: '设计素材',
    categorySlug: 'sheji-sucai',
    image: 'https://readdy.ai/api/search-image?query=Modern%20UI%20design%20component%20library%20with%20colorful%20buttons%20forms%20navigation%20bars%20and%20cards%20on%20a%20clean%20minimal%20workspace%20with%20warm%20ambient%20lighting%20professional%20design%20studio%20setting%20flat%20lay%20top%20view%20organized%20layout&width=800&height=600&seq=resource-01&orientation=landscape',
    date: '2024-12-15',
    views: 12840,
    downloads: 3650,
    tags: ['UI组件', 'Figma', '设计系统', '组件库'],
    contentHtml: '<p>这是一套精心整理的UI设计组件库合集，包含了2024年最流行的设计风格和交互模式。无论你是资深设计师还是刚入门的新手，这套组件库都能帮助你快速搭建高质量的用户界面。</p><h3>组件库亮点</h3><p>本套组件库涵盖按钮、输入框、选择器、导航栏、卡片、弹窗、表格等200+种常用界面组件，全部采用矢量化设计，支持无限缩放不失真。每个组件都经过精心调校，确保在不同尺寸和分辨率下都有出色的显示效果。</p><h3>兼容性</h3><p>同时提供Figma和Sketch两种主流设计工具的源文件，导入即可使用。所有组件均采用自动布局和组件变体功能，修改主组件即可批量更新所有实例，大幅提升设计效率。</p><h3>适用场景</h3><p>适用于网页设计、移动端APP设计、后台管理系统、电商平台、社交应用等多种项目类型。组件风格简约现代，可灵活定制颜色、圆角、间距等参数，满足不同品牌的视觉需求。</p>',
    isFeatured: true,
    isLatest: false,
  },
  {
    id: 2,
    title: '4K自然风光航拍视频素材包',
    description: '30组高质量4K航拍素材，包含山川、湖泊、森林、海岸线等壮丽自然景观，色彩还原真实，后期调色空间充裕。',
    category: '影视素材',
    categorySlug: 'yingshi-sucai',
    image: 'https://readdy.ai/api/search-image?query=Aerial%20drone%20photography%20of%20stunning%20mountain%20landscapes%20with%20lakes%20and%20forests%20during%20golden%20hour%20warm%20sunlight%20natural%20color%20grading%20cinematic%20look%204K%20quality%20vibrant%20greens%20and%20blues&width=800&height=600&seq=resource-02&orientation=landscape',
    date: '2024-12-10',
    views: 9520,
    downloads: 2840,
    tags: ['4K视频', '航拍', '自然风光', '视频素材'],
    contentHtml: '<p>这套4K自然风光航拍视频素材包由专业航拍团队历时三个月拍摄完成，覆盖了中国多个知名自然风景区，每一帧画面都经过精心构图和色彩校正。</p><h3>素材规格</h3><p>全部素材以3840×2160分辨率录制，采用H.265编码，画质清晰细腻。色彩空间为Rec.709，方便与各类剪辑软件无缝对接。帧率包含24fps和30fps两种选择，满足不同创作需求。</p><h3>内容列表</h3><p>素材包包含：山川远景10组、湖泊倒影8组、森林穿越6组、海岸线3组、日出日落3组。每组素材时长30秒至2分钟不等，总计约45分钟的高质量航拍内容。</p>',
    isFeatured: true,
    isLatest: false,
  },
  {
    id: 3,
    title: '免版税商用背景音乐合集Vol.3',
    description: '50首精选免版税背景音乐，包含抒情、激昂、轻松、电子等多种风格，适用于视频创作、播客、商业广告等场景。',
    category: '音乐素材',
    categorySlug: 'yinyue-sucai',
    image: 'https://readdy.ai/api/search-image?query=Professional%20music%20production%20studio%20with%20headphones%20audio%20mixing%20console%20and%20sound%20waves%20visualization%20warm%20ambient%20lighting%20creative%20workspace%20with%20musical%20notes%20floating%20in%20air%20elegant%20composition&width=800&height=600&seq=resource-03&orientation=landscape',
    date: '2024-12-08',
    views: 7230,
    downloads: 1980,
    tags: ['背景音乐', '免版税', '商用音乐', 'BGM'],
    contentHtml: '<p>《免版税商用背景音乐合集Vol.3》是系列作品的第三辑，在前两辑的基础上进一步扩充了音乐风格和曲目数量，为内容创作者提供更丰富的音频素材选择。</p><h3>音乐风格</h3><p>本合集共收录50首原创背景音乐，涵盖抒情钢琴、激昂管弦、轻快电子、爵士蓝调、氛围音乐、民谣吉他等六大风格，每首曲目都经过专业混音和母带处理，音质达到商业级标准。</p><h3>使用授权</h3><p>所有曲目均采用CC0协议发布，可免费用于个人和商业项目，包括视频制作、播客节目、商业广告、游戏开发等场景，无需署名，无需额外付费。</p>',
    isFeatured: false,
    isLatest: true,
  },
  {
    id: 4,
    title: 'Figma设计系统搭建完全指南',
    description: '从零开始学习如何在Figma中搭建可扩展的设计系统，包含颜色系统、字体层级、组件变体、自动布局等核心知识。',
    category: '教程资源',
    categorySlug: 'jiaocheng-ziyuan',
    image: 'https://readdy.ai/api/search-image?query=Figma%20design%20software%20interface%20on%20a%20large%20monitor%20showing%20color%20palettes%20typography%20scales%20and%20component%20variants%20in%20a%20modern%20design%20studio%20with%20warm%20lighting%20clean%20desk%20setup&width=800&height=600&seq=resource-04&orientation=landscape',
    date: '2024-12-05',
    views: 5640,
    downloads: 1520,
    tags: ['Figma', '设计系统', '教程', 'UI设计'],
    contentHtml: '<p>本教程将手把手教你从零开始在Figma中搭建一套完整、可扩展的设计系统。无论你是独立设计师还是团队负责人，掌握设计系统的搭建方法都将极大提升你的工作效率和设计一致性。</p><h3>课程大纲</h3><p>第一章：设计系统概述与规划 — 了解设计系统的核心价值和搭建前的准备工作。第二章：颜色系统 — 建立主色、辅助色、中性色和语义化颜色的完整色板。第三章：字体层级 — 定义标题、正文、标注等各层级的字体样式。第四章：组件库 — 使用变体和自动布局构建灵活可复用的组件。第五章：文档与维护 — 编写组件使用文档，建立版本管理流程。</p>',
    isFeatured: true,
    isLatest: false,
  },
  {
    id: 5,
    title: '高端商务PPT模板套装2024',
    description: '50套精心设计的高端商务PPT模板，覆盖年终总结、产品发布、融资路演、企业介绍等多种场景，直接套用省时省力。',
    category: '模板资源',
    categorySlug: 'moban-ziyuan',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20presentation%20slides%20with%20modern%20minimal%20design%20clean%20layout%20charts%20and%20graphs%20on%20a%20warm%20toned%20desk%20setup%20with%20laptop%20and%20coffee%20elegant%20professional%20setting&width=800&height=600&seq=resource-05&orientation=landscape',
    date: '2024-12-03',
    views: 8340,
    downloads: 4210,
    tags: ['PPT模板', '商务演示', '年终总结', '模板'],
    contentHtml: '<p>高端商务PPT模板套装2024版全面升级，在保留经典商务风格的基础上融入了2024年最新的设计趋势，让你的每一次演示都给人留下深刻印象。</p><h3>模板分类</h3><p>本套装包含50套完整PPT模板，按场景分为五大系列：年终总结（12套）、产品发布（10套）、融资路演（8套）、企业介绍（12套）、培训课件（8套）。每套模板均包含封面、目录、过渡页、内容页、结束页等完整结构。</p><h3>设计特色</h3><p>全部模板采用16:9宽屏比例，适配主流投影和显示设备。配色方案经过专业搭配，图表和数据可视化元素一应俱全，只需替换文字和图片即可完成一份专业演示文稿。</p>',
    isFeatured: false,
    isLatest: true,
  },
  {
    id: 6,
    title: 'Chrome浏览器效率插件精选合集',
    description: '20款经过实测筛选的Chrome效率插件，涵盖标签管理、截图工具、翻译助手、广告拦截等实用功能，全面提升浏览体验。',
    category: '插件工具',
    categorySlug: 'chajian-gongju',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chrome%20browser%20extension%20icons%20arranged%20in%20a%20grid%20on%20a%20clean%20digital%20workspace%20with%20soft%20warm%20background%20modern%20tech%20aesthetic%20organized%20layout%20productivity%20tools%20concept&width=800&height=600&seq=resource-06&orientation=landscape',
    date: '2024-11-28',
    views: 6780,
    downloads: 2930,
    tags: ['Chrome', '插件', '效率工具', '浏览器扩展'],
    contentHtml: '<p>在日常工作中，一款好用的浏览器插件可以节省大量时间和精力。本合集精选了20款经过实际使用验证的Chrome效率插件，覆盖多个使用场景，让你的浏览器变身超级工作台。</p><h3>插件分类</h3><p>标签管理类（4款）：解决打开太多标签页的混乱问题。截图工具类（3款）：支持全屏截图、区域截图和滚动截图。翻译助手类（3款）：一键翻译网页内容，支持多语言互译。广告拦截类（2款）：净化浏览环境，提升页面加载速度。开发工具类（4款）：前端开发调试利器。其他实用工具（4款）：密码管理、剪贴板增强等。</p>',
    isFeatured: false,
    isLatest: true,
  },
  {
    id: 7,
    title: '3D图标与插画素材大礼包',
    description: '500+精美3D风格图标和场景插画，涵盖商务、科技、教育、医疗、金融等20+行业主题，支持PNG和SVG双格式导出。',
    category: '设计素材',
    categorySlug: 'sheji-sucai',
    image: 'https://readdy.ai/api/search-image?query=Colorful%203D%20rendered%20icons%20and%20illustrations%20in%20various%20categories%20like%20business%20technology%20education%20and%20healthcare%20arranged%20on%20a%20soft%20pastel%20background%20modern%20design%20aesthetic%20clean%20composition&width=800&height=600&seq=resource-07&orientation=landscape',
    date: '2024-11-25',
    views: 10980,
    downloads: 4870,
    tags: ['3D图标', '插画', '设计素材', 'PNG'],
    contentHtml: '<p>这套3D图标与插画素材大礼包是目前平台上最受欢迎的设计资源之一。所有素材均由专业3D设计师使用Blender和Cinema 4D制作，质感细腻、光影真实。</p><h3>素材规格</h3><p>全部500+素材提供两种分辨率选择：2K（2048×2048）适用于网页和APP设计，4K（4096×4096）适用于印刷和大型展示。文件格式包含带透明通道的PNG格式和矢量SVG格式，满足不同场景的使用需求。</p><h3>风格特点</h3><p>采用当下流行的玻璃拟态和柔和阴影设计风格，色彩搭配和谐统一，在深色和浅色背景下均有出色表现。所有图标保持一致的视觉语言，可自由混搭组合使用。</p>',
    isFeatured: true,
    isLatest: false,
  },
  {
    id: 8,
    title: '短视频剪辑转场特效包Pro',
    description: '200+专业级视频转场特效，包含平滑过渡、动态模糊、光效转场、故障特效等多种风格，兼容Pr、FCPX、DaVinci等主流剪辑软件。',
    category: '影视素材',
    categorySlug: 'yingshi-sucai',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20with%20colorful%20transition%20effects%20and%20motion%20graphics%20on%20a%20professional%20editing%20software%20interface%20dark%20mode%20with%20vibrant%20visual%20elements%20creative%20post%20production%20workspace&width=800&height=600&seq=resource-08&orientation=landscape',
    date: '2024-11-22',
    views: 7560,
    downloads: 3120,
    tags: ['视频转场', '特效', '短视频', '剪辑'],
    contentHtml: '<p>短视频剪辑转场特效包Pro版专为短视频创作者打造，收录了200+种当下最流行的转场效果，让你的视频剪辑更加流畅专业，轻松吸引观众注意力。</p><h3>特效类型</h3><p>平滑过渡类（40种）：淡入淡出、推拉摇移等基础过渡效果。动态模糊类（30种）：速度感十足的动态模糊转场。光效转场类（35种）：炫目光影效果，适合科技感和时尚类内容。故障特效类（25种）：赛博朋克风格的故障艺术转场。创意转场类（70种）：遮罩、分割、翻转等创意转场方式。</p><h3>使用方式</h3><p>提供.prfpset（Premiere Pro）、.fcpx（Final Cut Pro）和.drx（DaVinci Resolve）三种格式的预设文件，导入即用，无需复杂设置。</p>',
    isFeatured: false,
    isLatest: false,
  },
  {
    id: 9,
    title: 'Python数据分析入门到精通',
    description: '零基础学Python数据分析，从环境搭建到实战项目，手把手教你使用Pandas、NumPy、Matplotlib等核心库完成数据分析全流程。',
    category: '教程资源',
    categorySlug: 'jiaocheng-ziyuan',
    image: 'https://readdy.ai/api/search-image?query=Python%20programming%20code%20on%20a%20laptop%20screen%20with%20data%20visualization%20charts%20and%20graphs%20in%20a%20modern%20workspace%20warm%20lighting%20clean%20desk%20with%20notebook%20and%20coffee%20professional%20developer%20setup&width=800&height=600&seq=resource-09&orientation=landscape',
    date: '2024-11-20',
    views: 8920,
    downloads: 3560,
    tags: ['Python', '数据分析', '编程教程', 'Pandas'],
    contentHtml: '<p>本教程专为编程零基础的学习者设计，从Python环境搭建开始，循序渐进地带领你掌握数据分析的核心技能。教程采用项目驱动教学法，每个知识点都配有实际案例和练习。</p><h3>课程结构</h3><p>第一阶段（第1-5章）：Python基础语法与环境配置。第二阶段（第6-10章）：NumPy数值计算与Pandas数据处理。第三阶段（第11-14章）：Matplotlib和Seaborn数据可视化。第四阶段（第15-18章）：实战项目 — 电商数据分析、用户行为分析、金融数据建模。总计18章、120+个知识点、30+个实战练习。</p>',
    isFeatured: false,
    isLatest: false,
  },
  {
    id: 10,
    title: '电商详情页设计模板合集',
    description: '80套高转化率电商详情页设计模板，覆盖服装、数码、美妆、食品、家居五大品类，直接套用快速出图。',
    category: '模板资源',
    categorySlug: 'moban-ziyuan',
    image: 'https://readdy.ai/api/search-image?query=Ecommerce%20product%20detail%20page%20design%20templates%20on%20a%20designer%20monitor%20showing%20fashion%20electronics%20cosmetics%20and%20home%20goods%20layouts%20clean%20modern%20aesthetic%20with%20warm%20studio%20lighting&width=800&height=600&seq=resource-10&orientation=landscape',
    date: '2024-11-18',
    views: 6340,
    downloads: 2780,
    tags: ['电商设计', '详情页', '淘宝', '模板'],
    contentHtml: '<p>电商详情页设计模板合集专为电商运营和设计师打造，收录80套经过市场验证的高转化率详情页模板，按品类分类整理，查找使用方便快捷。</p><h3>模板内容</h3><p>服装类（20套）：涵盖女装、男装、童装等细分品类。数码类（18套）：手机配件、电脑外设、智能家居等。美妆类（16套）：护肤品、彩妆、个人护理等。食品类（14套）：零食、特产、健康食品等。家居类（12套）：家具、家纺、厨具、装饰品等。</p><h3>设计特点</h3><p>所有模板均遵循电商平台的视觉规范，包含产品主图区、卖点展示区、规格参数区、细节展示区、使用场景区和购买引导区等完整的详情页结构。提供PSD和Figma两种源文件格式。</p>',
    isFeatured: false,
    isLatest: true,
  },
  {
    id: 11,
    title: '高端品牌VI设计手册合集',
    description: '收录50个国际知名品牌VI设计规范手册，包含Logo使用规范、色彩系统、字体系统、应用场景等完整品牌视觉指导。',
    category: '设计素材',
    categorySlug: 'sheji-sucai',
    image: 'https://readdy.ai/api/search-image?query=Brand%20identity%20design%20manual%20pages%20with%20logo%20guidelines%20color%20palettes%20and%20typography%20systems%20spread%20on%20a%20minimal%20white%20desk%20elegant%20professional%20branding%20portfolio%20layout&width=800&height=600&seq=resource-11&orientation=landscape',
    date: '2024-11-15',
    views: 4560,
    downloads: 1890,
    tags: ['VI设计', '品牌手册', 'Logo规范', '品牌设计'],
    contentHtml: '<p>这套高端品牌VI设计手册合集是从全球顶级设计机构的公开资源中精心整理而成，是学习品牌设计的绝佳参考资料。通过研究这些经典案例，你将深入理解品牌视觉系统的构建逻辑和设计方法。</p><h3>收录品牌</h3><p>合集涵盖科技、金融、零售、餐饮、文化传媒等多个行业领域的50个品牌VI手册，包括多个国际知名品牌。每本手册都详细展示了Logo的规范使用、色彩体系、辅助图形、字体层级和应用场景等核心内容。</p><h3>学习价值</h3><p>通过对比分析不同品牌的VI设计思路，你可以学习到：品牌核心视觉元素的提炼方法、跨媒介视觉一致性保证策略、品牌升级与迭代的设计逻辑。</p>',
    isFeatured: false,
    isLatest: false,
  },
  {
    id: 12,
    title: '免费可商用中文字体包2024',
    description: '精心整理30款免费可商用的优质中文字体，包含宋体、黑体、楷体、手写体等多种风格，含授权说明文档。',
    category: '设计素材',
    categorySlug: 'sheji-sucai',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20typography%20samples%20displayed%20elegantly%20showing%20different%20font%20styles%20serif%20sans%20serif%20handwriting%20and%20calligraphy%20on%20a%20warm%20paper%20texture%20background%20artistic%20typography%20layout&width=800&height=600&seq=resource-12&orientation=landscape',
    date: '2024-11-12',
    views: 11230,
    downloads: 5230,
    tags: ['中文字体', '免费商用', '字体包', '设计资源'],
    contentHtml: '<p>字体是设计中最重要的元素之一，但商用字体的授权费用往往让人望而却步。本合集精心整理了30款确认可免费商用的优质中文字体，每款字体都附带授权说明文档，让你用得放心。</p><h3>字体分类</h3><p>宋体系列（8款）：思源宋体、方正书宋等经典宋体风格。黑体系列（10款）：思源黑体、阿里巴巴普惠体等现代黑体。楷体系列（4款）：兼具传统韵味和现代审美的楷体字。手写体系列（5款）：个性鲜明的创意手写字体。标题字体（3款）：适合海报和标题使用的展示字体。</p>',
    isFeatured: false,
    isLatest: true,
  },
];

export const faqItems: FaqItem[] = [
  {
    question: '无码专区的资源都可以免费下载吗？',
    answer: '是的，无码专区所有资源均免费提供下载。我们致力于为设计师和创作者打造一个开放、优质的资源共享平台，所有资源均经过版权审核，确保用户可放心使用。部分资源可能附带有特定的使用协议，下载时请留意资源详情页的授权说明。',
  },
  {
    question: '下载的资源可以用于商业项目吗？',
    answer: '大部分资源支持商业使用，但具体授权范围因资源而异。每个资源详情页都会明确标注授权类型（个人使用、商业使用、CC0等），请在下载前仔细阅读授权条款。如果你对某个资源的商业使用有疑问，可以通过关于我们页面的联系方式咨询。',
  },
  {
    question: '如何快速找到我需要的资源？',
    answer: '无码专区提供多种资源查找方式：你可以通过顶部的分类导航按资源类型浏览；也可以使用搜索功能输入关键词查找；首页的精选推荐和最新更新栏目也会每日更新优质资源。建议将常用分类加入书签，方便下次快速访问。',
  },
  {
    question: '资源更新频率是怎样的？',
    answer: '无码专区保持每日更新，确保你始终能获取到最新、最优质的创作资源。我们的内容团队每天精选并审核上架10-20个新资源，同时定期更新已有资源的最新版本。订阅我们的更新通知，不错过任何优质内容。',
  },
  {
    question: '如何联系无码专区团队？',
    answer: '你可以通过关于我们页面上的联系方式与我们取得联系。无论是资源建议、版权问题还是合作意向，我们都会在24小时内回复。也欢迎通过社交媒体关注我们的最新动态。',
  },
  {
    question: '上传的资源有质量问题怎么办？',
    answer: '无码专区对上传的所有资源都有严格的质量审核流程。如果你发现某个资源存在质量问题（如文件损坏、内容不符等），请立即通过联系方式反馈给我们，我们会在核实后第一时间处理，并持续优化审核流程以提供更好的用户体验。',
  },
];

export const testimonials = [
  {
    name: '李明',
    role: 'UI设计师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20male%20designer%20in%20a%20modern%20studio%20with%20warm%20lighting%20friendly%20expression%20clean%20background&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '作为一名独立设计师，无码专区简直是我的素材宝库。UI组件库和图标资源质量非常高，大大提升了我的工作效率，强烈推荐给所有设计师朋友！',
    rating: 5,
  },
  {
    name: '王芳',
    role: '视频创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20female%20videographer%20with%20camera%20in%20a%20creative%20studio%20warm%20lighting%20genuine%20smile%20artistic%20background&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '影视素材区的4K航拍素材和转场特效包太实用了！质量完全不输付费素材网站，更新速度也很快，现在每次创作前都会先来无码专区逛逛。',
    rating: 5,
  },
  {
    name: '张伟',
    role: '创业者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Asian%20male%20entrepreneur%20in%20a%20modern%20office%20with%20warm%20lighting%20confident%20expression%20business%20casual%20attire&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '创业初期预算有限，无码专区的PPT模板和字体资源帮了大忙。商业计划书和产品介绍的演示文稿全靠这里的模板，效果相当专业。',
    rating: 4,
  },
];

export const stats = {
  totalResources: 4307,
  totalDownloads: 128000,
  totalUsers: 56000,
  dailyUpdates: 15,
};